import { apiSlice } from "./apiSlice";

const apiSliceWithTags = apiSlice.enhanceEndpoints({
  addTagTypes: ["Questions"],
});

const questionApiSlice = apiSliceWithTags.injectEndpoints({
  endpoints: (builder) => ({
    getQuestions: builder.query({
      query: ({ page = 1, per_page = 10, is_approved = null, subject = null, level = null, sort_by = null } = {}) => {
        let url = `/questions/mine?page=${page}&per_page=${per_page}`;
        if (is_approved !== null) url += `&is_approved=${is_approved}`;
        if (subject) url += `&subject=${subject}`;
        if (level) url += `&level=${level}`;
        if (sort_by) url += `&sort_by=${sort_by}`;
        return url;
      },
      providesTags: ["Questions"],
    }),
    getSchoolQuestions: builder.query({
      query: ({ page = 1, per_page = 10, is_approved = null, subject = null, level = null, sort_by = null } = {}) => {
        let url = `/questions/school?page=${page}&per_page=${per_page}`;
        if (is_approved !== null) url += `&is_approved=${is_approved}`;
        if (subject) url += `&subject=${subject}`;
        if (level) url += `&level=${level}`;
        if (sort_by) url += `&sort_by=${sort_by}`;
        return url;
      },
      providesTags: ["Questions"],
    }),
    getQuestion: builder.query({
      query: (id) => `/question/${id}`,
      providesTags: ["Questions"],
    }),
    createQuestion: builder.mutation({
      query: (values) => ({
        url: "/question",
        method: "POST",
        body: { ...values },
      }),
      invalidatesTags: ["Questions"],
    }),
    createBulkQuestion: builder.mutation({
      query: (values) => ({
        url: "/question/bulk",
        method: "POST",
        body: { ...values },
      }),
      invalidatesTags: ["Questions"],
    }),
    editQuestion: builder.mutation({
      query: ({ values, questionId }) => ({
        url: `/question/${questionId}`,
        method: "PUT",
        body: { ...values },
      }),
      invalidatesTags: ["Questions"],
    }),
    addComment: builder.mutation({
      query: (values) => ({
        url: `/questionreview`,
        method: "POST",
        body: { ...values },
      }),
      invalidatesTags: ["Questions"],
    }),
    getReviewedQuestions: builder.query({
      query: ({ page = 1, per_page = 10, sort_by = null } = {}) => {
        let url = `/questions/reviewed?page=${page}&per_page=${per_page}`;
        if (sort_by) url += `&sort_by=${sort_by}`;
        return url;
      },
      providesTags: ["Questions"],
    }),
    getPendingReviewQuestions: builder.query({
      query: ({ page = 1, per_page = 10, sort_by = null } = {}) => {
        let url = `/questions/pending-review?page=${page}&per_page=${per_page}`;
        if (sort_by) url += `&sort_by=${sort_by}`;
        return url;
      },
      providesTags: ["Questions"],
    }),
    deleteQuestion: builder.mutation({
      query: (id) => ({
        url: `/question/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Questions"],
    }),
    getMyClasses: builder.query({
      query: () => "/classroom/all/mine",
    }),
    getClassroomSubjects: builder.query({
      query: ({ classroom_id }) => `/classroom/${classroom_id}/subjects`,
    }),
    getClassroomStudents: builder.query({
      query: ({ classroom_id }) => `/classroom/${classroom_id}/students`,
    }),
    getTeacherSubjects: builder.query({
      query: () => "/teacher/subjects",
    }),
    getTeacherOverviewStats: builder.query({
      query: () => "/teacher/overview/stats",
    }),
    getReviewerStats: builder.query({
      query: () => "/questions/reviewer/stats",
      providesTags: ["Questions"],
    }),
  }),
});

export const {
  useGetQuestionsQuery,
  useGetSchoolQuestionsQuery,
  useGetQuestionQuery,
  useCreateQuestionMutation,
  useCreateBulkQuestionMutation,
  useEditQuestionMutation,
  useAddCommentMutation,
  useDeleteQuestionMutation,
  useGetReviewedQuestionsQuery,
  useGetPendingReviewQuestionsQuery,
  useGetMyClassesQuery,
  useGetClassroomSubjectsQuery,
  useGetClassroomStudentsQuery,
  useGetTeacherSubjectsQuery,
  useGetTeacherOverviewStatsQuery,
  useGetReviewerStatsQuery,
} = questionApiSlice;
